<div class="organization-members-card">
  <company-block-card [title]="'LABELS.MEMBERS_AND_ROLES_MANAGEMENT'" [isMarginBottom]="true">
    <ng-container card-actions>
      <div *ngIf="!(isTablet$ | async) && isAdmin" class="header-container__actions" (click)="openInviteSideBar()">
        <img src="assets/icons/icon_add_gray.svg" />
        <span>{{ "LABELS.INVITE_MEMBERS" | translate }}</span>
      </div>
    </ng-container>

    <ng-container card-body>
      <table class="organization-members-card__table">
        <thead>
          <tr>
            <th>{{ "LABELS.MEMBERS_DETAILS" | translate | uppercase }}</th>
            <th *ngIf="!(isMobileMode$ | async)">{{ "LABELS.ROLE" | translate | uppercase }}</th>
            <th *ngIf="!(isMobileMode$ | async)">{{ "LABELS.STATUS" | translate | uppercase }}</th>
            <th *ngIf="!(isMobileMode$ | async)">{{ "LABELS.TEAMS" | translate | uppercase }}</th>
            <th *ngIf="!(isMobileMode$ | async)"></th>
          </tr>
        </thead>
        <tbody>
          <!--Active Members-->
          <tr *ngFor="let member of uniqueOrganizationMembers">
            <td>
              <div class="members-details-container">
                <app-gravatar [acronymText]="member.user.firstName.charAt(0) + member.user.lastName.charAt(0)" [isStacked]="false" />
                <div class="members-details">
                  <span class="members-details__value">{{ member?.user.firstName + " " + member?.user.lastName }}</span>
                  <span class="members-details__label">{{ member?.user.email }}</span>
                </div>
              </div>
            </td>

            <td *ngIf="!(isMobileMode$ | async)">
              <span class="cell-value">
                {{ "LABELS.MEMBER_ROLES." + enumOrganizationRole[member?.role] | translate }}
              </span>
            </td>

            <td *ngIf="!(isMobileMode$ | async)">
              <p class="active-status">Active</p>
            </td>

            <td *ngIf="!(isMobileMode$ | async)" class="cell-value">
              {{ getOrganizationMembersCompanyNames(member) | translate }}
            </td>

            <td>
              <ng-container *ngIf="isMemberEditAllowed(member)">
                <ng-container *ngTemplateOutlet="memberOptionsDropdown"></ng-container>
              </ng-container>
            </td>

            <ng-template #memberOptionsDropdown>
              <div class="organization-members-card__view-settings-menu" dropdown container="body" placement="bottom right">
                <button
                  id="organization-members-card__view-settings-menu-{{ member?.user.userId }}"
                  dropdownToggle
                  type="button"
                  class="btn btn-link organization-members-card__view-settings-menu-btn"
                >
                  <i class="fa fa-ellipsis-h"></i>
                </button>
                <ul
                  id="organization-members-card__view-settings-dropdown-{{ member?.user.userId }}"
                  class="organization-members-card__view-settings-menu-list"
                  role="menu"
                  *dropdownMenu
                >
                  <li role="menuitem" class="cursor-pointer" (click)="openInviteSideBar(member)">
                    <div class="organization-members-card__view-settings-menu-item">
                      <div class="organization-members-card__view-settings-menu-item-img-container">
                        <img
                          src="assets/icons/icon_edit_gray.svg"
                          class="organization-members-card__view-settings-menu-item-img organization-members-card__view-settings-menu-item-img-edit"
                        />
                      </div>
                      <span>{{ "BUTTON.EDIT_PERMISSIONS" | translate }}</span>
                    </div>
                  </li>
                  <li role="menuitem" class="cursor-pointer" (click)="deleteOrganizationMember.emit(member?.user.userId)">
                    <div class="organization-members-card__view-settings-menu-item">
                      <div class="organization-members-card__view-settings-menu-item-img-container">
                        <img
                          src="assets/icons/trash_gray.svg"
                          class="organization-members-card__view-settings-menu-item-img organization-members-card__view-settings-menu-item-img-delete"
                        />
                      </div>
                      <span>{{ "BUTTON.DELETE" | translate }}</span>
                    </div>
                  </li>
                </ul>
              </div>
            </ng-template>
          </tr>

          <!--Invited Members-->
          <tr *ngFor="let member of uniqueOrganizationInvitedMembers">
            <td>
              <div class="members-details-container">
                <app-gravatar [acronymText]="member?.userEmail" [isStacked]="false" />
                <div class="members-details">
                  <span class="members-details__label">{{ member?.userEmail }}</span>
                </div>
              </div>
            </td>

            <td *ngIf="!(isMobileMode$ | async)">
              <span class="cell-value">
                {{ "LABELS.MEMBER_ROLES." + enumOrganizationRole[member?.role] | translate }}
              </span>
            </td>

            <td *ngIf="!(isMobileMode$ | async)">
              <p class="invited-status">Invited</p>
              <p class="invited-date">{{ member.invitedDate | customDateByUtc }}</p>
            </td>

            <td class="cell-value" *ngIf="!(isMobileMode$ | async)">
              {{ getOrganizationInvitedMembersCompanyNames(member) | translate }}
            </td>

            <td>
              <ng-container *ngIf="isInviteEditAllowed()">
                <ng-container *ngTemplateOutlet="inviteOptionsDropdown"></ng-container>
              </ng-container>
            </td>

            <ng-template #inviteOptionsDropdown>
              <div class="organization-members-card__view-settings-menu" dropdown container="body" placement="bottom right">
                <button
                  id="organization-members-card__view-settings-menu-invite"
                  dropdownToggle
                  type="button"
                  class="btn btn-link organization-members-card__view-settings-menu-btn"
                >
                  <i class="fa fa-ellipsis-h"></i>
                </button>
                <ul
                  id="organization-members-card__view-settings-menu-invite"
                  class="organization-members-card__view-settings-menu-list"
                  role="menu"
                  *dropdownMenu
                >
                  <li role="menuitem" class="cursor-pointer" (click)="resendInvite(member?.id)">
                    <div class="organization-members-card__view-settings-menu-item">
                      <div class="organization-members-card__view-settings-menu-item-img-container">
                        <img
                          src="assets/icons/icon_sync.svg"
                          class="organization-members-card__view-settings-menu-item-img organization-members-card__view-settings-menu-item-img-edit"
                        />
                      </div>
                      <span>{{ "RESEND" | translate }}</span>
                    </div>
                  </li>
                  <li role="menuitem" class="cursor-pointer" (click)="removeInvite(member?.id)">
                    <div class="organization-members-card__view-settings-menu-item">
                      <div class="organization-members-card__view-settings-menu-item-img-container">
                        <img
                          src="assets/icons/trash_gray.svg"
                          class="organization-members-card__view-settings-menu-item-img organization-members-card__view-settings-menu-item-img-delete"
                        />
                      </div>
                      <span>{{ "BUTTON.DELETE" | translate }}</span>
                    </div>
                  </li>
                </ul>
              </div>
            </ng-template>
          </tr>
        </tbody>
      </table>
      <div class="organization-members-card__invite-button" *ngIf="(isTablet$ | async) && isAdmin" (click)="openInviteSideBar()">
        <img src="assets/icons/icon_add_gray.svg" />
        <span class="link">{{ "LABELS.INVITE_MEMBERS" | translate }}</span>
      </div>
    </ng-container>
  </company-block-card>
</div>
